import { useMutation } from "@tanstack/react-query";
import { vacancyStatusSettingsQueryKeys } from "@/hooks/queries/useVacancyStatusSettings";
import { vacancyStatusSettingsService } from "@/services/vacancyStatusSettingsService";


// Define mutation keys for mutations.
export const vacancyStatusSettingsMutationKeys = {
    all: ["vacancyStatusSettings"],
    list: () => [...vacancyStatusSettingsMutationKeys.all, "list"],
    details: (id) => [...vacancyStatusSettingsMutationKeys.all, "detail", id],
    create: () => [...vacancyStatusSettingsMutationKeys.all, "create"],
};



// create vacancy status settings
export const useCreateVacancyStatusSettings = (vacancyId, vacancyStatusId) => {
    return useMutation({
        mutationKey: vacancyStatusSettingsMutationKeys.create(),
        mutationFn: (data) => vacancyStatusSettingsService.createVacancyStatusSettings(vacancyId, vacancyStatusId, data),
    });
};
